import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, Effect, ofType} from '@ngrx/effects';
import { Store} from '@ngrx/store';

import {
  GotoPlayerAction, GotoPlayerMultiAction,
  LoadQuickSearchAction,
  LoadQuickSearchFailAction,
  LoadQuickSearchSuccessAction, quickSearchActionType
} from '../actions/quick-search';
import {go} from '../actions/router';
import {ArrayResponse} from '../models/array-response';
import {QuickSearchResult} from '../models/quick-search-result';
import {SendBackResult} from '../models/send-back-result';
import * as fromShared from '../reducers';
import {QuickSearchService} from '../services/quick-search.service';

import {BaseEffect} from './base.effect';
import {debug} from '../../../rxjs-operators';
import { map, withLatestFrom, switchMap, catchError } from 'rxjs/operators';
import {empty,  of} from 'rxjs';

@Injectable()
export class QuickSearchEffect extends BaseEffect {

  applyActions$ = createEffect(() => { return   this.actions$.pipe(
        ofType(quickSearchActionType.SEARCH, quickSearchActionType.PAGE_TO, quickSearchActionType.CHANGE_PAGE_SIZE, quickSearchActionType.ORDER_BY),
        debug('Quick search action received.'),
        map(() => new LoadQuickSearchAction(true))
    )});


  load$ = createEffect(() => { return  this.actions$.pipe(
      ofType(quickSearchActionType.LOAD),
      debug('Perform quick search.'),
      withLatestFrom(this.store.select(fromShared.selectors.getQuickSearchFilter)),
      switchMap(([action, filter]) => this.quickSearchService.getList(filter).pipe(
        map((payload: SendBackResult<ArrayResponse<QuickSearchResult>>) => new LoadQuickSearchSuccessAction(payload.data)),
        catchError(res => this.catchResponseError(res))
      )),
    )});

  loadSuccess$ = createEffect(() => { return this.actions$.pipe( ofType(quickSearchActionType.LOAD_SUCCESS),
    switchMap((action: LoadQuickSearchSuccessAction) => {
    switch (action.payload.count) {
      case 0:
        return empty();
      case 1:
        return action.payload.array[0].clientName !== 'Storever' ?
          (action.payload.array[0].subscriptionCount !== 1 ? of (new GotoPlayerMultiAction(action.payload.array[0])) :
            of (new GotoPlayerAction(action.payload.array[0]))) : empty();
      default:
        return empty();
    }
  }))
  });

  gotoPlayer$ = createEffect(() => { return this.actions$.pipe(
      ofType(quickSearchActionType.GOTO_PLAYER)
      , debug('Go to player details action received.')
      // bf37431a-92ba-429c-bb6c-cec1a08b7c5c/sites/detail/0a8b6140-3d6c-42c7-90d0-827023e57bd0
      , map((action: GotoPlayerAction) => go([action.payload.clientUuid, 'sites', 'detail', action.payload.siteUuid])))
  });

  gotoPlayerMulti$ = createEffect(() => { return this.actions$.pipe(
    ofType(quickSearchActionType.GOTO_PLAYER_MULTI)
    , debug('Go to player details action received detail-multi.')
    // bf37431a-92ba-429c-bb6c-cec1a08b7c5c/sites/detail/0a8b6140-3d6c-42c7-90d0-827023e57bd0
    , map((action: GotoPlayerAction) => go([action.payload.clientUuid, 'sites', 'detail-multi', action.payload.siteUuid , action.payload.subscriptionUuid])))
  });

  constructor(private actions$: Actions,
              private store: Store<fromShared.AppState>,
              private quickSearchService: QuickSearchService,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadQuickSearchFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadQuickSearchFailAction(response['error'].message);
  }
}
